module.exports = __webpack_public_path__ + "img/icon_more_wh.f5501e20.svg";